import styled from 'styled-components/macro';

const ItemCheckBox = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  margin-right: 8px;
  border-radius: 50%;
  border: 1px solid #a69d9f;
  transition: border-color 0.25s ease-out, background-color 0.25s ease-out;

  ${props => props.hover && `
    border-color: #fff;
    background-color: #552cba;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #fff;
    }
  `}
`;

export default ItemCheckBox;
